/* eslint-disable no-unused-vars */
import TagService from "@/services/tag";

import { ADD_TAGS, SET_TAGS, DELETE_TAG } from "./types";

export async function fetchTags({commit}, params) {
  const {data} = await TagService.get(params);
  const tags = data.data.tags;
  commit(SET_TAGS, tags);
  return tags;
}

export async function addTag({commit}, params) {
  const {data} = await TagService.create(params);
  const tag = data.data.tag;
  commit(ADD_TAGS, tag);
  return data;
}

export async function assignTag({commit}, params) {
  const {data} = await TagService.assign(params);
  return data;
}

export async function deleteTag({commit}, params) {
  const tagId = params.id;
  const {data} = await TagService.delete(params);
  commit(DELETE_TAG, tagId);
  return data;
}